import axios from "../api/axios";
//import React from "react";
import useAuth from "./useAuth";
import { useNavigate, useLocation } from "react-router-dom";

const useRefreshToken = () => {
  const { setAuth } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const refresh = async () => {
    //{\"acc\": \"" + $.trim($('#setup-clientcode-input-win').val().toUpperCase()) + "\", \"p\": \"" + $.trim($('#setup-pin-input-win').val()) + "\"}
    let response;
    try {
      response = await axios.get("/auth/refreshToken", {
        withCredentials: true,
      });
    } catch (err) {
      // Refresh token expired or invalid — clear auth and redirect to login
      setAuth({});
      navigate("/login", { state: { from: location }, replace: true });
      return null;
    }

    setAuth((prev) => {
      // console.log("prev: ", JSON.stringify(prev));
      // console.log("currentData: ", response.data);
      if (prev.userProfile) {
        return {
          ...prev,
          userProfile: { ...prev.userProfile || {} },
          accountCode: response.data.clientIdentifier,
          accessToken: response.data.accessToken,
          userData: response.data,
          driverPoiSettings: localStorage.getItem("driverPoiSettings"),
        };
      } else {
        return {
          ...prev,
          userProfile: {},
          accountCode: response.data.clientIdentifier,
          accessToken: response.data.accessToken,
          userData: response.data,
          driverPoiSettings: localStorage.getItem("driverPoiSettings"),
        };
      }
    });
    return response.data.accessToken;
  };

  return refresh;
};

export default useRefreshToken;
